import React from 'react';

// Virtuali lietuviškų raidžių klaviatūra - bendras komponentas
const LithuanianKeyboard = ({ onInsert, compact = false }) => {
  const letters = ['ą', 'č', 'ę', 'ė', 'į', 'š', 'ų', 'ū', 'ž', 'Ą', 'Č', 'Ę', 'Ė', 'Į', 'Š', 'Ų', 'Ū', 'Ž'];
  
  if (compact) {
    // Kompaktinė versija registracijos formoms
    return (
      <div className="flex flex-wrap gap-1 justify-center mt-2 p-2 bg-[#0f0f23]/50 rounded-lg border border-[#d4af37]/20">
        <span className="w-full text-[10px] text-gray-500 text-center mb-1">Lietuviškos raidės:</span>
        {letters.map((letter) => (
          <button
            key={letter}
            type="button"
            onClick={() => onInsert(letter)}
            className="w-6 h-6 rounded bg-[#d4af37]/10 hover:bg-[#d4af37]/30 text-[#d4af37] font-medium text-xs transition-all duration-200 border border-[#d4af37]/20 hover:scale-110"
          >
            {letter}
          </button>
        ))}
      </div>
    );
  }
  
  // Standartinė versija
  return (
    <div className="flex flex-wrap gap-1.5 justify-center mt-3 p-3 bg-secondary/30 rounded-lg border border-border/50">
      {letters.map((letter) => (
        <button
          key={letter}
          type="button"
          onClick={() => onInsert(letter)}
          className="w-8 h-8 rounded bg-amber-500/20 hover:bg-amber-500/40 text-amber-400 font-medium text-sm transition-all duration-200 border border-amber-500/30 hover:scale-110"
        >
          {letter}
        </button>
      ))}
    </div>
  );
};

export default LithuanianKeyboard;
